import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const button = css`
	& svg {
		& [stroke] {
			stroke: currentColor;
		}
	}
`;

export const Root = styled.div`
	display: flex;
	flex-direction: column;
	padding: 2rem;
	border-radius: var(--radius-l);
	background-color: var(--color-grey-10-solid);
	gap: 2.4rem;
`;

export const Section = styled.section`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
`;

export const Footer = styled.footer`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 1.2rem;
`;
